import React, { useRef } from 'react';

type TProps = {
  poster: string;
  videoSrc: string;
  className?: string;
}

export const HoverVideo: React.FC<TProps> = ({ className, poster, videoSrc }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleMouseEnter = () => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Playback prevented:", error);
      });
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  return (
    <video
      className={className}
      ref={videoRef}
      height="100%"
      width="100%"
      poster={poster}
      muted
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      loop
    >
      <source src={videoSrc} type="video/mp4" />
    </video>
  );
}
